import OperationalReportPage from './OperationalReportPage';
export default function AttendanceExceptionsReportPage(){return <OperationalReportPage kind="attendance-exceptions"/>;}
